// Utilidades de fechas (locales, sin desfase de zona horaria) y estilos de alerta de ocupación.

export function dateToStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function strToDate(s) {
  const [y, m, d] = (s || dateToStr(new Date())).split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function todayStr() {
  return dateToStr(new Date());
}

export function addDaysStr(s, n) {
  const d = strToDate(s);
  d.setDate(d.getDate() + n);
  return dateToStr(d);
}

export function startOfWeekStr(s) {
  const d = strToDate(s);
  const dow = (d.getDay() + 6) % 7; // lunes = 0
  d.setDate(d.getDate() - dow);
  return dateToStr(d);
}

export function formatFechaLarga(s) {
  return strToDate(s).toLocaleDateString("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

const MESES_ABR = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

// Fecha corta con mes abreviado en español, ej: "30 jun 2026" (evita el formato ISO "2026-06-30").
export function formatFechaCorta(s) {
  if (!s) return "—";
  const d = strToDate(s);
  if (Number.isNaN(d.getTime())) return s;
  return `${d.getDate()} ${MESES_ABR[d.getMonth()]} ${d.getFullYear()}`;
}

export function diaSemanaCorto(s) {
  return strToDate(s).toLocaleDateString("es-ES", { weekday: "short" });
}

// Hora local (HH:MM) a partir de un datetime ISO (ej. created_at de Mongo), para
// mostrar cuándo ingresó un correo/reserva a la Bandeja y poder priorizar por urgencia.
export function formatHoraIngreso(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
}

export const ALERTA = {
  verde: {
    bar: "bg-emerald-500",
    text: "text-emerald-700",
    chip: "bg-emerald-50 text-emerald-700 border-emerald-200",
    border: "border-slate-200",
    dot: "bg-emerald-500",
    label: "Disponible",
  },
  amarillo: {
    bar: "bg-amber-500",
    text: "text-amber-700",
    chip: "bg-amber-50 text-amber-700 border-amber-200",
    border: "border-amber-200",
    dot: "bg-amber-500",
    label: "Casi llena · 80%",
  },
  rojo: {
    bar: "bg-red-500",
    text: "text-red-700",
    chip: "bg-red-50 text-red-700 border-red-200",
    border: "border-red-200",
    dot: "bg-red-500",
    label: "Llena · 100%",
  },
  cerrada: {
    bar: "bg-slate-400",
    text: "text-slate-600",
    chip: "bg-slate-100 text-slate-600 border-slate-300",
    border: "border-slate-300",
    dot: "bg-slate-400",
    label: "Cerrada",
  },
  sin_programar: {
    bar: "bg-slate-300",
    text: "text-slate-500",
    chip: "bg-white text-slate-500 border-dashed border-slate-300",
    border: "border-dashed border-slate-300",
    dot: "bg-slate-300",
    label: "Sin programar",
  },
};
